// Add IntersectionObserver to IE
import 'intersection-observer';

import 'mutation-observer';

// IE thought it was a good idea to rename matches
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector;
}
